import Vue from 'vue'
import Vuex from 'vuex'
import Fetch from '../fetch/fly'

Vue.use(Vuex)

// 用户信息
const userinfo = localStorage.getItem('userinfo') ? JSON.parse(localStorage.getItem('userinfo')) : {}
const userAuthInfo = localStorage.getItem('userAuthInfo') ? JSON.parse(localStorage.getItem('userAuthInfo')) : {}
// 用来重置state
const getDefaultState = () => {
  return {
    userinfo,
    userAuthInfo // 用户信息
  }
}
export default new Vuex.Store({
  state: getDefaultState(),
  mutations: {
    // 重置state
    RESETSTATE(state) {
      Object.assign(state, getDefaultState())
    },
    // 设置用户信息
    SET_USERINFO(state, res) {
      state.userinfo = res
    },
    // 设置用户认证信息
    SET_USERAUTHINFO(state, res) {
      state.userAuthInfo = res
    }
  },
  actions: {
    // 重置state
    resetState({ commit }) {
      commit('resetState')
    },
    // 获取用户信息
    getUserinfo() {
      // const params = {
      //   uriCode: 'API008'
      // }
      // const res = await Fetch(params)
      // localStorage.setItem('userinfo', JSON.stringify(res))
      // commit('SET_USERINFO', res)
    },
    async getUserAuthInfo() {
      const params = {
        uriCode: 'API012'
      }
      const res = await Fetch(params)
      localStorage.setItem('userAuthInfo', JSON.stringify(res))
      // commit('SET_USERAUTHINFO', res)
    }
  },
  modules: {}
})
